import { useTranslation } from 'react-i18next';
import { ApiError, NetworkError } from '../api/client.ts';

/**
 * Traduce un error a algo que el usuario pueda leer.
 *
 * El `message` que manda el backend está en español y es para depurar: NUNCA se enseña.
 * Lo que se traduce es el `code`, que es estable y forma parte del contrato.
 */
export function useErrorMessage(): (error: unknown) => string {
  const { t } = useTranslation();

  return (error: unknown): string => {
    if (error instanceof NetworkError) return t('errors.network');
    if (error instanceof ApiError) {
      // Si el código no tiene traducción, mensaje genérico: mejor eso que enseñar un
      // identificador interno o el texto en español del servidor.
      const key = `errors.${error.code}`;
      const translated = t(key);
      return translated === key ? t('errors.unexpected') : translated;
    }
    return t('errors.unexpected');
  };
}

export function ErrorAlert({ error }: { error: unknown }) {
  const describe = useErrorMessage();
  if (!error) return null;
  return (
    <p className="aviso-error mb-4" role="alert" data-test="error">
      {describe(error)}
    </p>
  );
}
